<template>
  <div>
    <div style="cursor:pointer;margin-right:10px" @click="validation()" v-if="purpose == 'validation'">
      <div style="color:rgb(204, 51, 51)">Validasi</div>
    </div>
    <div v-if="purpose == 'k3lResend' || purpose == 'kplhResend'" style="cursor:pointer;margin-right:10px"
      @click="mailResend()">
      <div style="color:rgb(204, 51, 51)">Resend Email</div>
    </div>
    <div v-if="purpose == 'approveKplhHead'" style="cursor:pointer;margin-right:10px" @click="approveKplhHead()">
      <div style="color:rgb(204, 51, 51)">Approve</div>
    </div>
    <div v-if="purpose == 'approveKtt'" style="cursor:pointer;margin-right:10px" @click="approveKtt()">
      <div style="color:rgb(204, 51, 51)">Approve</div>
    </div>
    <div v-if="purpose == 'reviewHeadHse'" style="cursor:pointer;margin-right:10px" @click="parentFunction">
      <div style="color:rgb(204, 51, 51)">Need Review</div>
    </div>
    <div v-if="purpose == 'reviewKtt'" style="cursor:pointer;margin-right:10px" @click="parentFunction">
      <div style="color:rgb(204, 51, 51)">Need Review</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  props: ['id', 'user_id', 'validation_url', 'purpose', 'parentFunction'],
  methods: {
    validation() {
      const url = `${process.env.VUE_APP_LANDINGPAGE_URL}${this.validation_url}/${this.id}/${this.user_id}`
      window.open(url, '_blank')
    },
    mailResend() {
      switch (this.purpose) {
        case 'k3lResend':
          this.resend('modalResendEmailK3l')
          break
        case 'kplhResend':
          this.resend('modalResendEmailKplh')
          break

        default:
          break
      }
    },
    resend(modalName) {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: modalName,
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'request_id',
        value: this.id,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 6,
      })
    },
    async approveKplhHead() {
      try {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve-head-hse/${this.$route.params.id}`,
          data: {
            note: '',
            user_id: this.$store.state.userid,
          },
        })

        if (data && data.status == 'success') {
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          this.$store.commit('SET_NOTIF', data.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
    async needReviewHeadKplh() { },
    async approveKtt() {
      try {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve-ktt/${this.$route.params.id}`,
          data: {
            note: '',
            user_id: this.$store.state.userid,
          },
        })

        if (data && data.status == 'success') {
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          this.$store.commit('SET_NOTIF', data.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
  },
}
</script>
